import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DsButtonModule, DsModalModule } from '@bmw-ds/components';

import { RootTextBlock } from '../../model/nsc-consent-legal-text';
import { LegalTextComponent } from './legal-text.component';

@Component({
  selector: 'cdf-legal-expandable',
  imports: [LegalTextComponent, DsButtonModule, DsModalModule],
  template: `
    <cdf-legal-text [legalText]="rootLegalText()" />

    @if (rootLegalText().popup?.text) {
      <ds-button class="information" icon="information" size="sm" variant="ghost" [ds-modal-trigger-for]="popupText" />

      <ds-modal #popupText>
        <ds-box-content>
          <cdf-legal-text [legalText]="rootLegalText()" class="text-paragraph" />
          <cdf-legal-text [legalText]="rootLegalText().popup!" />
        </ds-box-content>
      </ds-modal>
    }
  `,
  styleUrl: './legal-expandable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalExpandableComponent {
  readonly rootLegalText = input.required<RootTextBlock>();
}
